import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const includes = ['7 kompletnych tomów', '3 bonusy dla nauczyciela', '568 stron gotowych do wydruku', 'Materiały po polsku', 'Dostęp cyfrowy zaraz po zakupie', 'Jednorazowa płatność: 17 USD'];
export function ClosingBlock() {
  return <section className="w-full bg-navy px-5 py-16 sm:py-24" data-id="element-67" data-mp="20rjgxs1dvylt">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-68" data-mp="20suhlizj8q8p">
        <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-69" data-mp="1n1zgisv9zdfo">
          Mniej szukania. Więcej jasnych lekcji. Chemia gotowa wtedy, kiedy jej potrzebujesz.
        </h2>
        <p className="mt-4 text-lg font-medium text-white/70 sm:text-xl" data-id="element-70" data-mp="1d2qpa7rsocx0">
          Wizualna Chemia™ | Edycja 2026
        </p>

        <ul className="mt-9 grid w-full max-w-md gap-3 text-left" data-id="element-71" data-mp="3sk64axnlvps3">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-72" data-mp="3dv9x12tdigsj">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/10 text-white" data-id="element-73" data-mp="3dx36sqza9h4r">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-74" data-mp="aejoohabjrno" />
              </span>
              <span className="text-sm leading-relaxed text-white/85" data-id="element-75" data-mp="acp4542ym1k4">{item}</span>
            </li>)}
        </ul>

        <div className="mt-10 w-full max-w-md" data-id="element-76" data-mp="gvhgrvj0rom">
          <CTAButton label="Rozpocznij z Wizualną Chemią™ — 17 USD" data-id="element-77" data-mp="g3x6d7dqgdn" />
          <p className="mt-3 text-center text-xs text-white/60" data-id="element-78" data-mp="5ef6mmtriovc">
            Bez abonamentu • Dostęp cyfrowy od razu
          </p>
        </div>
      </motion.div>
    </section>;
}